import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { getSiteType } from '../../../utils/analytics';

export function trackProfessionalSearchClick(queryString: string, deviceType: TDevice) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Map',
    label: 'ProfSearch',
    page: {
      pageType: 'Map',
      siteType: getSiteType(deviceType),
      queryString,
    },
  });
}
